var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaxlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5837 9.74992H19.5003V4.33325H8.66699V9.74992H7.82199C7.22616 9.08909 6.38116 8.66658 5.41699 8.66658C3.61866 8.66658 2.16699 10.1183 2.16699 11.9166V19.4999C2.16699 21.2983 3.61866 22.7499 5.41699 22.7499C6.38116 22.7499 7.22616 22.3274 7.82199 21.6666H23.8337V12.9999C23.8337 11.2016 22.382 9.74992 20.5837 9.74992ZM6.50033 19.4999C6.50033 20.0958 6.01283 20.5833 5.41699 20.5833C4.82116 20.5833 4.33366 20.0958 4.33366 19.4999V11.9166C4.33366 11.3208 4.82116 10.8333 5.41699 10.8333C6.01283 10.8333 6.50033 11.3208 6.50033 11.9166V19.4999ZM10.8337 6.49992H17.3337V9.74992H10.8337V6.49992ZM21.667 19.4999H8.66699V11.9166H20.5837C21.1795 11.9166 21.667 12.4041 21.667 12.9999V19.4999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2503 15.1667C16.8486 15.1667 17.3337 14.6816 17.3337 14.0833C17.3337 13.485 16.8486 13 16.2503 13C15.652 13 15.167 13.485 15.167 14.0833C15.167 14.6816 15.652 15.1667 16.2503 15.1667Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5003 15.1667C20.0986 15.1667 20.5837 14.6816 20.5837 14.0833C20.5837 13.485 20.0986 13 19.5003 13C18.902 13 18.417 13.485 18.417 14.0833C18.417 14.6816 18.902 15.1667 19.5003 15.1667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2503 18.4167C16.8486 18.4167 17.3337 17.9316 17.3337 17.3333C17.3337 16.735 16.8486 16.25 16.2503 16.25C15.652 16.25 15.167 16.735 15.167 17.3333C15.167 17.9316 15.652 18.4167 16.2503 18.4167Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5003 18.4167C20.0986 18.4167 20.5837 17.9316 20.5837 17.3333C20.5837 16.735 20.0986 16.25 19.5003 16.25C18.902 16.25 18.417 16.735 18.417 17.3333C18.417 17.9316 18.902 18.4167 19.5003 18.4167Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13H14.0833V18.4167H9.75V13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaxlogo);
export default __webpack_public_path__ + "static/media/faxlogo.1722e0c1c64b958351c11ad5eca70ca7.svg";
export { ForwardRef as ReactComponent };